import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";

export const FinalCTA = ({ headline = ["STOP GUESSING.", "START BUILDING."], ctaLabel, ctaHref, note }) => (
  <section className="bg-accent" data-testid="final-cta-section">
    <div className="mx-auto max-w-6xl px-6 py-24 sm:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#0B0B0B]/70" data-testid="final-cta-kicker">
          Ready when you are
        </p>
        <h2
          className="mt-6 font-display text-5xl uppercase leading-[0.92] tracking-tight text-[#0B0B0B] sm:text-6xl lg:text-7xl"
          data-testid="final-cta-headline"
        >
          {headline.map((line, i) => (
            <span key={i} className="block">{line}</span>
          ))}
        </h2>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <a
            href={ctaHref}
            target={ctaHref.startsWith("http") ? "_blank" : undefined}
            rel={ctaHref.startsWith("http") ? "noopener noreferrer" : undefined}
            data-testid="final-cta-button"
            className="inline-flex items-center gap-2 bg-[#0B0B0B] px-10 py-5 font-mono text-sm font-bold uppercase tracking-[0.15em] text-white transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.45)]"
          >
            {ctaLabel}
            <ArrowUpRight className="h-4 w-4 text-accent" />
          </a>
          {note && (
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#0B0B0B]/70" data-testid="final-cta-note">
              {note}
            </p>
          )}
        </div>
      </Reveal>
    </div>
  </section>
);
